// extracted by mini-css-extract-plugin
export var actionButton = "_83-1";
export var actionButtons = "_83-2";
export var actions = "_83-0";
export var aiUnread = "_83-10";
export var alignCenter = "_83-h";
export var backWrapper = "_83-3";
export var cellContainer = "_83-4";
export var checkboxContainer = "_83-5";
export var contentContainer = "_83-6";
export var contentHeader = "_83-8";
export var conversationsTableWrapper = "_83-s";
export var draftReplyBadgeContainer = "_83-m";
export var dropdownItem = "_83-b";
export var dropdownItemsContainer = "_83-a";
export var dropdownTitle = "_83-c";
export var errorIcon = "_83-7";
export var filter = "_83-d";
export var gray = "_83-i";
export var headerActionButtons = "_83-e";
export var headerCheckboxContainer = "_83-f";
export var icon = "_83-j";
export var menuContainer = "_83-k";
export var noMoreTicketsIcon = "_83-12";
export var noMoreTicketsSubText = "_83-13";
export var oneLine = "_83-l";
export var optionsButton = "_83-n";
export var plus = "_83-o";
export var portalButtonsWrapper = "_83-g";
export var red = "_83-p";
export var scrolledTop = "_83-9";
export var search = "_83-q";
export var selectedConversationsCount = "_83-r";
export var spinner = "_83-t";
export var strong = "_83-u";
export var summaryCell = "_83-v";
export var tableContainer = "_83-11";
export var tagContainer = "_83-w";
export var threeDots = "_83-x";
export var twoLines = "_83-y";
export var unread = "_83-z";